import type { NextPage } from "next";

const Home: NextPage = () => {
    return <div>BUYER APP</div>;
};

export default Home;
